/* eslint-disable */

export const protobufPackage = "od_protos.journey.data.categories";

export interface HomeGuideCategory {
  event?: { $case: "valuation"; valuation: HomeGuideCategory_ValuationEvent } | {
    $case: "qualification";
    qualification: HomeGuideCategory_QualificationEvent;
  } | undefined;
}

/** Next ID: 6 */
export interface HomeGuideCategory_ValuationEvent {
  addressToken: string;
  sellerInputUuid?: string | undefined;
  source: HomeGuideCategory_ValuationEvent_ValuationSource;
  valuationCents: number;
  compsAddressUuids: string[];
}

/** Next ID: 3 */
export enum HomeGuideCategory_ValuationEvent_ValuationSource {
  UNKNOWN_SOURCE = 0,
  VALUATION_API = 1,
  BALLPARK = 2,
  UNRECOGNIZED = -1,
}

export function homeGuideCategory_ValuationEvent_ValuationSourceFromJSON(
  object: any,
): HomeGuideCategory_ValuationEvent_ValuationSource {
  switch (object) {
    case 0:
    case "UNKNOWN_SOURCE":
      return HomeGuideCategory_ValuationEvent_ValuationSource.UNKNOWN_SOURCE;
    case 1:
    case "VALUATION_API":
      return HomeGuideCategory_ValuationEvent_ValuationSource.VALUATION_API;
    case 2:
    case "BALLPARK":
      return HomeGuideCategory_ValuationEvent_ValuationSource.BALLPARK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HomeGuideCategory_ValuationEvent_ValuationSource.UNRECOGNIZED;
  }
}

export function homeGuideCategory_ValuationEvent_ValuationSourceToJSON(
  object: HomeGuideCategory_ValuationEvent_ValuationSource,
): string {
  switch (object) {
    case HomeGuideCategory_ValuationEvent_ValuationSource.UNKNOWN_SOURCE:
      return "UNKNOWN_SOURCE";
    case HomeGuideCategory_ValuationEvent_ValuationSource.VALUATION_API:
      return "VALUATION_API";
    case HomeGuideCategory_ValuationEvent_ValuationSource.BALLPARK:
      return "BALLPARK";
    case HomeGuideCategory_ValuationEvent_ValuationSource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface HomeGuideCategory_QualificationEvent {
  sellerInputId: string;
  qualificationDecision: HomeGuideCategory_QualificationEvent_QualificationDecision;
}

export enum HomeGuideCategory_QualificationEvent_QualificationDecision {
  UNKNOWN = 0,
  PRODUCT_QUALIFIED = 1,
  PRODUCT_DENIED = 2,
  PRODUCT_UNDENIED = 3,
  UNRECOGNIZED = -1,
}

export function homeGuideCategory_QualificationEvent_QualificationDecisionFromJSON(
  object: any,
): HomeGuideCategory_QualificationEvent_QualificationDecision {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return HomeGuideCategory_QualificationEvent_QualificationDecision.UNKNOWN;
    case 1:
    case "PRODUCT_QUALIFIED":
      return HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED;
    case 2:
    case "PRODUCT_DENIED":
      return HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED;
    case 3:
    case "PRODUCT_UNDENIED":
      return HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HomeGuideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED;
  }
}

export function homeGuideCategory_QualificationEvent_QualificationDecisionToJSON(
  object: HomeGuideCategory_QualificationEvent_QualificationDecision,
): string {
  switch (object) {
    case HomeGuideCategory_QualificationEvent_QualificationDecision.UNKNOWN:
      return "UNKNOWN";
    case HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_QUALIFIED:
      return "PRODUCT_QUALIFIED";
    case HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_DENIED:
      return "PRODUCT_DENIED";
    case HomeGuideCategory_QualificationEvent_QualificationDecision.PRODUCT_UNDENIED:
      return "PRODUCT_UNDENIED";
    case HomeGuideCategory_QualificationEvent_QualificationDecision.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseHomeGuideCategory(): HomeGuideCategory {
  return { event: undefined };
}

export const HomeGuideCategory = {
  fromJSON(object: any): HomeGuideCategory {
    return {
      event: isSet(object.valuation)
        ? { $case: "valuation", valuation: HomeGuideCategory_ValuationEvent.fromJSON(object.valuation) }
        : isSet(object.qualification)
        ? { $case: "qualification", qualification: HomeGuideCategory_QualificationEvent.fromJSON(object.qualification) }
        : undefined,
    };
  },

  toJSON(message: HomeGuideCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "valuation") {
      obj.valuation = HomeGuideCategory_ValuationEvent.toJSON(message.event.valuation);
    }
    if (message.event?.$case === "qualification") {
      obj.qualification = HomeGuideCategory_QualificationEvent.toJSON(message.event.qualification);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HomeGuideCategory>, I>>(base?: I): HomeGuideCategory {
    return HomeGuideCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HomeGuideCategory>, I>>(object: I): HomeGuideCategory {
    const message = createBaseHomeGuideCategory();
    if (
      object.event?.$case === "valuation" && object.event?.valuation !== undefined && object.event?.valuation !== null
    ) {
      message.event = {
        $case: "valuation",
        valuation: HomeGuideCategory_ValuationEvent.fromPartial(object.event.valuation),
      };
    }
    if (
      object.event?.$case === "qualification" &&
      object.event?.qualification !== undefined &&
      object.event?.qualification !== null
    ) {
      message.event = {
        $case: "qualification",
        qualification: HomeGuideCategory_QualificationEvent.fromPartial(object.event.qualification),
      };
    }
    return message;
  },
};

function createBaseHomeGuideCategory_ValuationEvent(): HomeGuideCategory_ValuationEvent {
  return { addressToken: "", sellerInputUuid: undefined, source: 0, valuationCents: 0, compsAddressUuids: [] };
}

export const HomeGuideCategory_ValuationEvent = {
  fromJSON(object: any): HomeGuideCategory_ValuationEvent {
    return {
      addressToken: isSet(object.addressToken) ? String(object.addressToken) : "",
      sellerInputUuid: isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : undefined,
      source: isSet(object.source) ? homeGuideCategory_ValuationEvent_ValuationSourceFromJSON(object.source) : 0,
      valuationCents: isSet(object.valuationCents) ? Number(object.valuationCents) : 0,
      compsAddressUuids: Array.isArray(object?.compsAddressUuids)
        ? object.compsAddressUuids.map((e: any) => String(e))
        : [],
    };
  },

  toJSON(message: HomeGuideCategory_ValuationEvent): unknown {
    const obj: any = {};
    if (message.addressToken !== "") {
      obj.addressToken = message.addressToken;
    }
    if (message.sellerInputUuid !== undefined) {
      obj.sellerInputUuid = message.sellerInputUuid;
    }
    if (message.source !== 0) {
      obj.source = homeGuideCategory_ValuationEvent_ValuationSourceToJSON(message.source);
    }
    if (message.valuationCents !== 0) {
      obj.valuationCents = Math.round(message.valuationCents);
    }
    if (message.compsAddressUuids?.length) {
      obj.compsAddressUuids = message.compsAddressUuids;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HomeGuideCategory_ValuationEvent>, I>>(
    base?: I,
  ): HomeGuideCategory_ValuationEvent {
    return HomeGuideCategory_ValuationEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HomeGuideCategory_ValuationEvent>, I>>(
    object: I,
  ): HomeGuideCategory_ValuationEvent {
    const message = createBaseHomeGuideCategory_ValuationEvent();
    message.addressToken = object.addressToken ?? "";
    message.sellerInputUuid = object.sellerInputUuid ?? undefined;
    message.source = object.source ?? 0;
    message.valuationCents = object.valuationCents ?? 0;
    message.compsAddressUuids = object.compsAddressUuids?.map((e) => e) || [];
    return message;
  },
};

function createBaseHomeGuideCategory_QualificationEvent(): HomeGuideCategory_QualificationEvent {
  return { sellerInputId: "", qualificationDecision: 0 };
}

export const HomeGuideCategory_QualificationEvent = {
  fromJSON(object: any): HomeGuideCategory_QualificationEvent {
    return {
      sellerInputId: isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
      qualificationDecision: isSet(object.qualificationDecision)
        ? homeGuideCategory_QualificationEvent_QualificationDecisionFromJSON(object.qualificationDecision)
        : 0,
    };
  },

  toJSON(message: HomeGuideCategory_QualificationEvent): unknown {
    const obj: any = {};
    if (message.sellerInputId !== "") {
      obj.sellerInputId = message.sellerInputId;
    }
    if (message.qualificationDecision !== 0) {
      obj.qualificationDecision = homeGuideCategory_QualificationEvent_QualificationDecisionToJSON(
        message.qualificationDecision,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HomeGuideCategory_QualificationEvent>, I>>(
    base?: I,
  ): HomeGuideCategory_QualificationEvent {
    return HomeGuideCategory_QualificationEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HomeGuideCategory_QualificationEvent>, I>>(
    object: I,
  ): HomeGuideCategory_QualificationEvent {
    const message = createBaseHomeGuideCategory_QualificationEvent();
    message.sellerInputId = object.sellerInputId ?? "";
    message.qualificationDecision = object.qualificationDecision ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
